"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _svg = _interopRequireDefault(require("../svg"));

var _markdown = _interopRequireDefault(require("../markdown"));

var _sections = _interopRequireDefault(require("../contentful-views/sections"));

var _navigationItem = _interopRequireDefault(require("../navigation/navigation-item"));

require("../../contentful-widgets/button-link");

require("./footer.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// ensure button-link widget is registered with Sections
var Footer = function Footer(_ref) {
  var globalFooterLinks = _ref.globalFooterLinks,
      globalFooterLogo = _ref.globalFooterLogo,
      globalFooterCopyright = _ref.globalFooterCopyright,
      globalFooterAddress = _ref.globalFooterAddress,
      NavigationItem = _ref.NavigationItem,
      children = _ref.children;

  var footerLinks = _lodash["default"].map(globalFooterLinks, function (group, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "grouping",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "title"
    }, group.title), /*#__PURE__*/_react["default"].createElement(_sections["default"], {
      sections: group.items
    }));
  }); // Notes:
  // privacy policy is still served from ecomm-core, so don't attempt to use react-isomorphic-link
  // children: render any extra content above the sitemap + company info, in this footer


  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Footer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "marketing"
  }, children, /*#__PURE__*/_react["default"].createElement("div", {
    className: "links"
  }, footerLinks)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "companyInfo"
  }, /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    className: "logo",
    core: false,
    svgAsset: globalFooterLogo
  }), /*#__PURE__*/_react["default"].createElement("a", {
    className: "csLink",
    href: "mailto:hello@glowforge.com"
  }, "hello@glowforge.com"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "copyright"
  }, /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    source: globalFooterCopyright
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "legal"
  }, /*#__PURE__*/_react["default"].createElement(NavigationItem, {
    tab: {
      local: true,
      text: 'Terms of Purchase and Service',
      url: '/terms'
    }
  }), /*#__PURE__*/_react["default"].createElement(NavigationItem, {
    tab: {
      local: false,
      text: 'Privacy Policy',
      url: '/privacy-policy'
    }
  }), /*#__PURE__*/_react["default"].createElement(NavigationItem, {
    tab: {
      local: true,
      text: 'Referral Program Terms',
      url: '/m/referral-terms'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "address"
  }, /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    source: globalFooterAddress
  })))));
};

Footer.propTypes = {
  // Contentful driven props -
  //    Footer is mostly populated from the raw contentful `global-footer`
  //    section data
  // globalFooterLinks: extracted from fields.content[{fields: {title, listItems}}]
  //  into fields.content[{title, items}] for only buttonLink items.
  //  This eventually gets applied as the grouped links for the left-side sitemap under
  //  .marketing > .links
  globalFooterLinks: _propTypes["default"].arrayOf(_propTypes["default"].any).isRequired,
  // globalFooterLogo: extracted from an entry in fields.content that has
  //   fields.id: 'glowforge-footer-logo', with the value from fields.svgAsset.
  //   Used in the companyInfo logo div
  globalFooterLogo: _propTypes["default"].objectOf(_propTypes["default"].any).isRequired,
  // globalFooterCopyright: from a fields.text field in fields.content with a footer-copyright id
  //   Used in the companyInfo div
  globalFooterCopyright: _propTypes["default"].string.isRequired,
  // globalFooterCopyright: from a fields.text field in fields.content, id: footer-company-address
  //   Used in the companyInfo div
  globalFooterAddress: _propTypes["default"].string.isRequired,
  // A NavigationItem component (see ui-common and ecomm-frontend declarations).
  NavigationItem: _propTypes["default"].func,
  // React elements to insert above the grouped links (sitemap), within the marketing div
  //   Currently used for email marketing sign-up.
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};
Footer.defaultProps = {
  NavigationItem: _navigationItem["default"],
  children: null
};
var _default = Footer;
exports["default"] = _default;